import React, {memo, useState, useRef} from "react";
import {useTranslation} from "react-i18next";
import {useField, useFormikContext} from "formik";
import {AutoComplete} from "antd";
import cn from "classnames";
import {SignContractCompanyInfoTag} from "pages/SignContracts/components/atoms/SignContractCompanyInfoTag";

export const SupplierField = memo(
  ({
    name,
    label,
    placeholder,
    disabled,
    highlightIfEmpty,
    hideErrorMessage,
    addClass,
    searchOrganizations,
  }) => {
    const {t} = useTranslation();
    const [field, meta, helpers] = useField(name);
    const {setFieldValue, values} = useFormikContext();
    const [data, setData] = useState([]);

    const selected = values.SupplierId
      ? data.find((item) => item.id === values.SupplierId) || values.Supplier
      : null;

    const timeoutRef = useRef();
    const handleSearch = (value) => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(async () => {
        const query = value?.trim() ?? "";
        setData(await searchOrganizations(query));
      }, 400);
    };

    const handleFocus = () =>
      !data.length && searchOrganizations("").then((res) => setData(res));

    const CompanyRow = ({item}) => (
      <div className="sign-contract-member-autocomplete__option-row full-width">
        <span className="row__organization">{item.name}</span>
        <SignContractCompanyInfoTag
          number={item.Company?.companyNumber}
          name={item.Company?.companyName}
          bordered
        />
      </div>
    );

    const options = data?.map((item) => ({
      value: item.id,
      text: <CompanyRow item={item} />,
    }));

    const setFields = async (item) => {
      await setFieldValue("SupplierId", item?.id ?? null);
      await setFieldValue("supplierName", item?.Company?.companyName ?? null);
      await setFieldValue("supplierCompanyNumber", item?.Company?.companyNumber ?? null);
    };

    const handleSelect = async (val) => {
      const selectedItem = data.find((item) => item.id === val);
      if (selectedItem) await setFields(selectedItem);
    };

    const handleDelete = () => {
      setFields();
      searchOrganizations("").then((res) => setData(res));
    };

    return (
      <div className={cn("form-field_wrapper", "__small", addClass ?? "mb-1")}>
        {label && <label className="__uppercase __bold fz-12 mb-2">{t(label)}</label>}
        <div className="full-width">
          {selected ? (
            <SignContractCompanyInfoTag
              number={selected?.Company?.companyNumber}
              name={selected?.Company?.companyName}
              onClose={handleDelete}
              bordered
            />
          ) : (
            <AutoComplete
              bordered={false}
              className={cn("input hght-38 full-width pt-[3]", {
                [addClass]: addClass,
                "bg-yellow": !!highlightIfEmpty,
              })}
              value={field.value}
              onChange={(value) => helpers.setValue(value)}
              onSelect={handleSelect}
              onBlur={() => helpers.setTouched(true)}
              onFocus={handleFocus}
              disabled={disabled}
              onSearch={handleSearch}
              filterOption={false}
              dataSource={options}
              dropdownMatchSelectWidth
              placeholder={t(placeholder)}
              popupClassName="recipients-tab_custom-select-dropdown sign-contract-member-autocomplete__dropdown"
            />
          )}
        </div>
        {meta.touched && meta.error && !hideErrorMessage && (
          <p className="form-error">{t(meta.error)}</p>
        )}
      </div>
    );
  }
);
